// src/components/ValuationCaption.jsx
// Légende à placer sous un total ou une valeur affichée seule : rappelle que la valeur est indicative et datée.
// Si une liste d'œuvres est fournie, signale combien d'estimations sont non datées ou de plus de 12 mois.
import React from "react";
import { useTranslation } from "react-i18next";
import { valuationDate, isStaleValuation, valuationText } from "../utils/valuationDisclosure";

export default function ValuationCaption({ artworks, className = "", style }) {
  const { i18n } = useTranslation();
  const lang = String(i18n.resolvedLanguage || i18n.language || "fr").slice(0, 2);
  const tx = valuationText(lang);
  const old = Array.isArray(artworks)
    ? artworks.filter((a) => !valuationDate(a) || isStaleValuation(valuationDate(a))).length
    : 0;
  return (
    <p className={className} style={{ margin: "6px 0 0", fontSize: 11, lineHeight: 1.4, color: "#8a8378", ...style }}>
      {tx.caption}
      {old > 0 ? ` ${tx.staleCount(old)}` : ""}
    </p>
  );
}
